// kb-configurator-add-delay.js
(function () {
  const DELAY_MS = 1000;

  // "our" configurator add-to-cart
  function isConfiguratorAddRequest(url, init) {
    try {
      if (!url || !String(url).includes('/cart/add.js')) return false;

      const body = init && init.body;

      // If it's FormData, check the marker or pplr
      if (body && typeof FormData !== 'undefined' && body instanceof FormData) {
        if (body.has('properties[_parent_candidate]')) return true;
        if (body.has('properties[_pplr_ref_variant]')) return true;
      }

      // If this is URLSearchParams / string
      if (typeof body === 'string') {
        if (body.includes('properties%5B_parent_candidate%5D=') || body.includes('properties[_parent_candidate]=')) return true;
        if (body.includes('_pplr_ref_variant')) return true;
      }

      // If there is no body, we still consider it a configurator only by the marker on the page.
      if (document.querySelector('input[name="properties[_parent_candidate]"]')) return true;

      return false;
    } catch (e) {
      return false;
    }
  }

  function sleep(ms) {
    return new Promise(r => setTimeout(r, ms));
  }

  // ---- FETCH WRAP ----
  const origFetch = window.fetch;

  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';

    const cfg = isConfiguratorAddRequest(url, init || {});
    if (cfg) {
      const qty = (() => {
        try {
          const b = init?.body;
          if (b instanceof FormData) return b.get('quantity');
        } catch (e) {}
        return null;
      })();

      console.groupCollapsed(
        `%c[KB delay] fetch /cart/add.js -> delay ${DELAY_MS}ms`,
        'color:#0a7;font-weight:bold'
      );
      console.log('url:', url);
      console.log('quantity:', qty);
      console.log('time:', new Date().toISOString());
      console.log('marker _parent_candidate:',
        init?.body instanceof FormData ? init.body.get('properties[_parent_candidate]') : null
      );
      console.groupEnd();

      await sleep(DELAY_MS);
      console.log('%c[KB delay] sending now (fetch)', 'color:#0a7');
      const res = await origFetch.call(this, input, init);

      // result log
      if (!res.ok) {
        const txt = await res.clone().text().catch(() => '');
        console.warn('[KB delay] add result NOT OK:', res.status, txt.slice(0, 300));
      } else {
        console.log('[KB delay] add result OK:', res.status);
      }
      return res;
    }

    return origFetch.call(this, input, init);
  };

  // ---- XHR WRAP ----
  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__kb_method = method;
    this.__kb_url = url;
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    const url = this.__kb_url || '';
    const initLike = { body };

    const cfg = isConfiguratorAddRequest(url, initLike);

    if (!cfg) return origSend.apply(this, arguments);

    const xhr = this;

    // so as not to interfere with synchronous sending (almost never happens)
    if (xhr.async === false) return origSend.apply(this, arguments);

    const qty = (() => {
      try {
        if (body instanceof FormData) return body.get('quantity');
      } catch (e) {}
      return null;
    })();

    console.groupCollapsed(
      `%c[KB delay] XHR /cart/add.js -> delay ${DELAY_MS}ms`,
      'color:#07a;font-weight:bold'
    );
    console.log('method:', xhr.__kb_method);
    console.log('url:', url);
    console.log('quantity:', qty);
    console.log('time:', new Date().toISOString());
    console.groupEnd();

    // intercept onload to log the status
    xhr.addEventListener('load', function () {
      if (xhr.status >= 400) {
        console.warn('[KB delay] XHR add NOT OK:', xhr.status, (xhr.responseText || '').slice(0, 300));
      } else {
        console.log('[KB delay] XHR add OK:', xhr.status);
      }
    });

    // delay before actual dispatch
    setTimeout(() => {
      console.log('%c[KB delay] sending now (XHR)', 'color:#07a');
      origSend.call(xhr, body);
    }, DELAY_MS);
  };

  console.log('%c[KB delay] configurator add delay patch enabled', 'color:#0a7;font-weight:bold');
})();
